export default __webpack_public_path__ + "computer.745ad4.svg";